/**
 * Vitesse de jeu choisie par le joueur : x1, x2 ou x3.
 *
 * Purement locale et visuelle côté serveur : la simulation avance par pas **identiques** à la
 * vitesse normale, simplement répétés à chaque image (voir `SceneParcours.update`). Les faits
 * transmis à la clôture d'une vague (spawnId tués, fuites, PV restants) sont donc les mêmes qu'à
 * x1, et le serveur — qui ne contrôle aucune durée — les valide de la même façon.
 *
 * Le choix vit **en mémoire** pour l'onglet : il suit le joueur d'un niveau à l'autre et repart à
 * x1 au rechargement. Aucun stockage navigateur, donc rien à déclarer au consentement.
 */
import { create } from 'zustand';

/** Vitesses proposées, dans l'ordre des boutons. */
export const VITESSES_JEU = [1, 2, 3] as const;

export type VitesseJeu = (typeof VITESSES_JEU)[number];

export const VITESSE_NORMALE: VitesseJeu = 1;

/** Vrai si `valeur` est une vitesse proposée (garde pour les entrées non typées). */
export function estVitesseJeu(valeur: unknown): valeur is VitesseJeu {
  return VITESSES_JEU.includes(valeur as VitesseJeu);
}

interface StoreVitesse {
  readonly vitesse: VitesseJeu;
  readonly definirVitesse: (vitesse: VitesseJeu) => void;
}

export const useVitesseJeu = create<StoreVitesse>((set) => ({
  vitesse: VITESSE_NORMALE,
  definirVitesse: (vitesse) => {
    set({ vitesse });
  },
}));

/** Remet la vitesse normale (tests, et tout départ qui doit repartir de x1). */
export function reinitialiserVitesseJeu(): void {
  useVitesseJeu.setState({ vitesse: VITESSE_NORMALE });
}
